import React from 'react';
import { Grid } from '@walmart-web/livingdesign-components';

import styles from './styles.module.css';
import ProductTestingActivityCard from './ProductTestingActivityCard/index.tsx';
import { useAppSelector } from '../../../../redux/hooks.ts';
import { ihutSelectors } from '../../../../redux/slices/ihut.ts';
import Skeleton from '../../../Skeleton';
import EmptyCart from '../../../EmptyCart/index.js';
import { useTranslation } from 'react-i18next';
import { IHUT_FEATURE_KEY } from '../../../../constants/common.js';
import withFeatureEnabled from '../../../../hoc/withFeatureEnabled/index.tsx';

const ProductTestingActivitiesGrid = () => {
  const { t } = useTranslation('ihut');
  const activities = useAppSelector(ihutSelectors.selectAvailableActivities);
  const loading = useAppSelector(ihutSelectors.selectLoading);

  if (loading)
    return (
      <div className={styles.loadingContainer}>
        <Skeleton count={10} />
      </div>
    );

  if (activities.length === 0)
    return (
      <EmptyCart
        id="EMPTY_CART"
        message={t('noActivities')}
        logoType="emptyCart"
      />
    );

  return (
    <Grid
      UNSAFE_className={styles.productTestingActivitiesContainer}
      data-testid="product-activities-container"
    >
      {activities.map((item) => (
        <ProductTestingActivityCard
          key={item.projectId}
          {...item}
          status={item.stepStatus}
          timestamp={item.completeBy}
        />
      ))}
    </Grid>
  );
};

export default withFeatureEnabled(
  ProductTestingActivitiesGrid,
  IHUT_FEATURE_KEY
);
